import React from 'react';
import Icon from '../../../components/AppIcon';

const DealAnalytics = ({ deals }) => {
  const totalDeals = deals?.length || 0;
  const activeDeals = deals?.filter(d => !['completed', 'cancelled']?.includes(d?.currentStage))?.length || 0;
  const completedDeals = deals?.filter(d => d?.currentStage === 'completed')?.length || 0;
  const totalValue = deals?.reduce((sum, d) => sum + (parseFloat(d?.proposedFee) || 0), 0)?.toFixed(1);
  
  const urgentDeals = deals?.filter(d => d?.isUrgent)?.length || 0;
  const overdueDeals = deals?.filter(d => {
    if (!d?.nextDeadline) return false;
    return new Date(d?.nextDeadline) < new Date();
  })?.length || 0;

  const avgDealValue = totalDeals > 0 ? (parseFloat(totalValue) / totalDeals)?.toFixed(1) : 0;
  const successRate = totalDeals > 0 ? ((completedDeals / totalDeals) * 100)?.toFixed(0) : 0;

  const metrics = [
    {
      label: 'Total Deals',
      value: totalDeals,
      icon: 'Briefcase',
      color: 'primary',
      trend: null
    },
    {
      label: 'Active Deals',
      value: activeDeals,
      icon: 'Activity',
      color: 'accent',
      trend: null
    },
    {
      label: 'Completed',
      value: completedDeals,
      icon: 'CheckCircle',
      color: 'success',
      trend: null
    },
    {
      label: 'Total Value',
      value: `€${totalValue}M`,
      icon: 'DollarSign',
      color: 'success',
      trend: null
    },
    {
      label: 'Avg Deal Value',
      value: `€${avgDealValue}M`,
      icon: 'TrendingUp',
      color: 'secondary',
      trend: null
    },
    {
      label: 'Success Rate',
      value: `${successRate}%`,
      icon: 'Award',
      color: 'primary',
      trend: null
    },
    {
      label: 'Urgent Deals',
      value: urgentDeals,
      icon: 'AlertCircle',
      color: 'destructive',
      trend: null
    },
    {
      label: 'Overdue',
      value: overdueDeals,
      icon: 'Clock',
      color: 'destructive',
      trend: null
    }
  ];

  return (
    <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
      {metrics?.map((metric, index) => (
        <div key={index} className="bg-card border border-border rounded-lg p-4">
          <div className="flex items-center justify-between mb-2">
            <div className={`w-10 h-10 bg-${metric?.color}/10 rounded-lg flex items-center justify-center`}>
              <Icon name={metric?.icon} size={20} color={`var(--color-${metric?.color})`} />
            </div>
            {metric?.trend && (
              <span className={`text-xs font-medium ${metric?.trend > 0 ? 'text-success' : 'text-destructive'}`}>
                {metric?.trend > 0 ? '+' : ''}{metric?.trend}%
              </span>
            )}
          </div>
          <div className="text-2xl font-bold text-foreground mb-1">{metric?.value}</div>
          <div className="text-xs text-muted-foreground">{metric?.label}</div>
        </div>
      ))}
    </div>
  );
};

export default DealAnalytics;